var NoteModel = require('../note'),
    _ = require('underscore'),
    fvChannel = require('glRadio').channel('FV');


module.exports = NoteModel.extend({

    consultsApplicable: true, // allow consults for all page note types
    ViewConstructor:  require('../../views/note/pageNote'),

    // See comment on document note parse from creating a compound id.
    // A unique key here is slightly different.
    parse: function(response) {

        var resp = NoteModel.prototype.parse.apply( this, arguments );

        if ( resp.sequence ) {
            resp.id = 'P_' +  resp.pageId + '_' + resp.sequence;
        }

        return resp;

    },

    /*
    * Note: not for get ( these are retrieved in bulk)
    * URL here is only for CRUD operations.
    * Note: from save, can't provide a documentModel parameter unless override Backbone.sync
    * ( eg notes from find and redact don't have this.document set )
    * */
    url: function( ) {

        var seq = this.get('sequence'),
            pageId = this.get('pageId'),
            creating = !pageId || seq === undefined;

        var url = fvChannel.request('apiUrl').pageNote(
            this.collection.document,
            pageId,
            creating ? undefined : seq
        );

        return url;

    },

    /*
    * TODO: mediate at the viewer level -- different page models based on mode ... this is the document mode page
    * */
    getPageModel: function() {
        return this.collection.document.pageCollection.findWhere({
            pageId: this.get('pageId')
        });
    }



});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/pgNote.js
 ** module id = 152
 ** module chunks = 0
 **/